// Builds the single toast for a problem-report submission response.
//
// The ToastProvider REPLACES the toast array on each show* call (it does not
// stack), so a safety notice must be combined with the route confirmation into
// one message — two consecutive calls would hide the route confirmation.

export interface ReportSubmissionToast {
  type: 'success' | 'info';
  message: string;
}

export interface ReportSubmissionResponse {
  message?: string;
  safety_notice?: string;
  report_id?: number | string;
  reference?: string;
}

/** Format the durable case id exactly as it appears in the support timeline. */
export function reportSupportReference(data: ReportSubmissionResponse | null | undefined): string | null {
  const provided = data?.reference?.trim().toUpperCase();
  if (provided) return provided;

  const reportId = typeof data?.report_id === 'string' ? Number(data.report_id) : data?.report_id;
  if (typeof reportId !== 'number' || !Number.isFinite(reportId)) return null;
  return `SUP-${String(reportId).padStart(6, '0')}`;
}

export function reportSubmissionToast(
  data: ReportSubmissionResponse | null | undefined,
): ReportSubmissionToast {
  const reference = reportSupportReference(data);
  const confirmation = [
    reference ? `Case ${reference} created.` : '',
    data?.message || (reference ? 'You can follow its status on the site.' : 'Problem report sent'),
  ].filter(Boolean).join(' ');
  if (data?.safety_notice) {
    return { type: 'info', message: `${confirmation} ${data.safety_notice}` };
  }
  return { type: 'success', message: confirmation };
}
